import { useDispatch, useDisplayAtMost } from "hooks";
import React from "react";
import * as styles from "./RepeatableContent.module.scss";
import { Typography } from "components/Typography";
import { Icon, navigate } from "library";
import { setModal } from "utilities/UI/uiSlice";
import { Button } from "components/Button";
import { optimizeBackgroundImageUrl } from "utilities/contentful";

type RepeatingContentType =
  Queries.ContentfulLandingPageQueryQuery["page"]["nodes"][number]["repeatingContent"][number];

export type RepeatableContentProps = {
  repeatableContent: RepeatingContentType;
  isOdd?: boolean;
};

export const RepeatableContent = ({
  repeatableContent,
  isOdd,
}: RepeatableContentProps) => {
  const isTablet = useDisplayAtMost("tablet");
  const dispatch = useDispatch();

  const image = {
    backgroundImage: optimizeBackgroundImageUrl(
      repeatableContent?.image?.file?.url,
      isTablet ? 600 : 1200,
    ),
  };

  return (
    <div className={styles.repeatableContent}>
      <div
        className={styles.contentContainer}
        style={{
          flexDirection: isTablet ? "column" : isOdd ? "row" : "row-reverse",
        }}
      >
        <div className={styles.image} style={image}></div>
        <div
          className={styles.content}
          style={{ alignItems: isOdd ? "flex-start" : "flex-end" }}
        >
          <Typography variant="h2" noSpacing>
            {repeatableContent?.heading}
          </Typography>
          <Typography
            variant="body"
            style={{ textAlign: isOdd ? "left" : "right" }}
            noSpacing
          >
            {repeatableContent?.description?.description}
          </Typography>
          <div>
            <Button
              variant="primary"
              icon={<Icon type="plus" className={styles.buttonIcon} />}
              onClick={() =>
                repeatableContent?.buttonUrl
                  ? navigate(repeatableContent?.buttonUrl)
                  : dispatch(setModal("signUp"))
              }
            >
              {repeatableContent?.buttonText}
            </Button>
          </div>
        </div>
      </div>
      <div
        className={styles.divider}
        style={{
          marginRight: isTablet ? (isOdd ? "auto" : "-9rem") : "auto",
          marginLeft: isTablet ? (isOdd ? "-9rem" : "auto") : "-6rem",
        }}
      ></div>
    </div>
  );
};
